/**
 * @file Manages the functionalities of User Access Control based on Groups->Roles->Counties.
 * @author Sri Pooja <sri.pooja@delasoft.com>
 */
import { Chip, Fab, IconButton } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEnvVariable } from '../../../../modules/environmentalList';
import { createRequest, requestApi } from '../../helpers/rest';
import CheckboxesTags from '../checkautocomplete';
import Switch from '../switch';


const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    colorPrimary: {
        backgroundColor: getEnvVariable('ModuleKey') === 'WRS' ? '#0076A5 !important' : '#1976d2 !important'
    }
});
const transformProps = {
    "Y": true,
    "N": false,
    true: "Y",
    false: "N"
}
export default function UserAccessControl({ options, ...props }) {
    const routeParams = useParams()
    const params = (props.dataItem && props.dataItem.userId) ? { Id: props.dataItem.userId } : routeParams;
    // const params = useParams();
    const classes = useStyles();
    const [data, setData] = useState(null)
    const [submodules, setSubmodules] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [user, setuser] = useState(null)
    const [userMoudleStatus, setUserModuleStatus] = useState(null)
    const [groupIndeterminate, setGroupIndeterminate] = useState(false)
    const [reload, setReload] = useState(false);
    const [authDetails, setAuthDetails] = useState(null)
    const [result, setResult] = useState(props.item || { isCalcualtedQuery: 'Y' })
    const { components, extraProps, match, dataItem } = props
    const { isprofile } = components
    const { read } = options ? options : {}
    var get = read.filter(e => e.type === 'get')
    var customProps = get.filter(e => e.customProps ? e : null)
    let ids = [], id;
    var urls = [];


    useEffect(() => {
        if (getEnvVariable('ModuleKey') === 'WRS' || getEnvVariable('ModuleKey') === 'AEPS' || getEnvVariable('ModuleKey') === 'LAOACS') {
            let read = [];
            let access_url = {
                "url": `${getEnvVariable('MasterAdmin')}/api/IPUsersAuthorizations/GetRequestByUserId/` + (props.dataItem.userId ? props.dataItem.userId : props.dataItem.Id),
                "type": 'get',
            };
            read.push(access_url);
            Promise.all(read.map(each => requestApi(createRequest(each, {}, params)))).then(resp => {
                const [reqAuthDetails] = resp
                setAuthDetails(reqAuthDetails)
                setRefresh(!refresh)
            })
        }
    }, [params.Id])

    /**
     * Initial Request to get the data
     */
    useEffect(() => {
        if (customProps.length > 0) {
            id = customProps ? (dataItem.Id || dataItem.userId) : null
        }
        if (options && options.read) {
            let read = options.read.filter(each => { if (each.type === 'get') return each })
            read = read.filter(each => each.customProps ? each.customProps : each.routeProps)
            if (id && read && customProps.length > 0) {
                read.forEach(e => {
                    var urls = e.url.slice(-1);
                    e.url = urls == "/" ? e.url + '' + id : e.url
                })
            }
            Promise.all(read.map(each => requestApi(createRequest(each, {}, params)))).then(resp => {
                const [accesscontrol, user, submodules, UserMoudleStatus] = resp
                setData(accesscontrol)
                setSubmodules(submodules)
                setuser(user)
                setUserModuleStatus(UserMoudleStatus)
            })
        }
    }, [params.Id])

    const handleSave = (modresult) => {
        let url = options.read.filter(each => { if (each.type === 'post') return each })
        requestApi(createRequest(url[0], data, params)).then(resp => {
            if (resp)
                setData(data);;
            // handleModuleSave(modresult);
        })

    }
    const handleModuleSave = (each, name) => {
        let moddata = []
        let usermoddaata
        // modresult && modresult.length > 0 && modresult.map(each => {

        if (each.checked || each.SubModuleName === name) {
            if (userMoudleStatus) {
                usermoddaata = userMoudleStatus.find(e => e.SubModuleId === each.Id);
            }
            moddata.push({ id: usermoddaata ? usermoddaata.Id : 0, userId: user.UserId, moduleId: each.ModuleId, subModuleId: each.Id, status: each.checked ? "A" : "I" });
            //{ id: 0, userId: user.UserId, moduleId: each.ModuleId, subModuleId: each.Id, status: each.Status }

        }
        // if(!each.checked)
        // {
        //     if(userMoudleStatus){
        //     usermoddaata = userMoudleStatus.filter(e=>e.SubModuleId !== each.Id);
        //     setUserModuleStatus(usermoddaata);
        //     }
        // }
        // if(userMoudleStatus){
        //     usermoddaata = userMoudleStatus.filter(e=>e.SubModuleId !== each.Id);
        //     setUserModuleStatus(usermoddaata);
        // }
        // moddata.push({ id: usermoddaata ? usermoddaata.Id : 0, userId: user.UserId, moduleId: each.ModuleId, subModuleId: each.Id, status: each.checked?"A":"I" });


        let url = options.read.filter(each => { if (each.type === 'post') return each })
        requestApi(createRequest(url[1], moddata, params)).then(resp => {
            if (resp)
                //setData(data)
                setUserModuleStatus(resp)
        })

    }
    const handleSubItems = (items, check) => {
        return items.map(each => {
            if (each && each.items && each.items.length > 0) {
                each.checked = check;
                handleSubItems(each.items, check)
            }
            else each.checked = check;
            return each
        })
    }

    /**
   * on click on group , selecting all the sub roles and counties
   */
    const checkGroupSection = (evt, index) => {
        evt.stopPropagation()
        let each = data[index];
        if (each && each.items && each.items.length > 0) {
            each.checked = !each.checked
            each.items = handleSubItems(each.items, each.checked);
        }
        else {
            each.checked = !each.checked
        }
        data[index] = each;
        setData(data);
        setRefresh(!refresh)
    }

    const checkRoleSection = (evt, index, parent) => {
        evt.stopPropagation()
        let each = data[parent]['items'][index];
        if (each && each.items && each.items.length > 0) {
            each.checked = !each.checked
            each.items = handleSubItems(each.items, each.checked);
        }
        else {
            each.checked = !each.checked
        }
        data[parent]['items'][index] = each;
        if (data[parent]) {
            if (data[parent]['items'].every(item => item.checked === true))
                data[parent].checked = true
            else data[parent].checked = false
        }
        setData(data);
        setRefresh(!refresh)
    }

    const handleCountyChange = (evt, parent, index) => {
        const { name, value } = evt.target
        let each = data[parent]['items'][index];
        let tempval = value.split(',');
        if (each && each.items && each.items.length > 0)
            each.items.map(item => {
                if (tempval.includes(item.id.toString())) {
                    item.checked = true;
                }
                else item.checked = false
            })
        data[parent]['items'][index] = each;
        if (data[parent] && data[parent]['items'][index] && data[parent]['items'][index].items) {
            if (data[parent]['items'][index].items.every(item => item.checked === true)) {
                data[parent].checked = true
                data[parent]['items'][index].checked = true
            }
            else {
                data[parent].checked = false
                data[parent]['items'][index].checked = false
            }
        }
        setGroupIndeterminate({ [parent]: data[parent]['items'][index].items.some(item => item.checked === true) ? true : false })

        setData(data);
        setRefresh(!refresh)
    }

    const handleIndetermineGroupCheck = (group) => {
        let indeterminate = false
        if (group && group.items && group.items.length > 0) {
            indeterminate = group.items.some(each => {
                return each.checked === true
            })
            if (indeterminate === false) {
                indeterminate = group.items.some(each => {
                    if (each && each.items && each.items.length > 0) {
                        return each.items.some(eachItem => {
                            return eachItem.checked === true
                        })
                    }
                })
            }
            return indeterminate
        }
        else return false
    }

    const handleModuletoggle = (event) => {
        const { name, checked } = event.target;
        const updatedSubmodules = submodules.map(each => {
            if (each.SubModuleName === name) {
                each.checked = checked;
                handleModuleSave(each, name);
            }
            return each;
        });
        setSubmodules(updatedSubmodules);
        setReload(!reload);
    };


    return <div className='col-12 py-1'>
        <div className='clearfix'></div>
        <Typography component={'title'}>{options.title || 'User Access Control'}</Typography>
        {<IconButton className='float-end ' size='small' color='primary' onClick={e => handleSave(result)}><SaveIcon /></IconButton>}
        <div className='clearfix'></div>
        {authDetails && (
            <Accordion defaultExpanded={true} elevation={1}>
                <AccordionSummary
                    style={{
                        backgroundColor: '#673ab7',
                        color: 'white',
                        maxHeight: '45px',
                        minHeight: '45px',
                    }}
                    expandIcon={<ExpandMoreIcon color='inherit' style={{ color: 'white' }} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>
                        Authorization Details : {" " + authDetails.FirstName + " " + authDetails.LastName}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails style={{ p: 1 }}>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td><small className='text-secondary'>FirstName:</small></td>
                                <td>{authDetails.FirstName}</td>
                                <td><small className='text-secondary'>LastName:</small></td>
                                <td>{authDetails.LastName}</td>
                            </tr>
                            <tr>
                                <td><small className='text-secondary'>Subject:</small></td>
                                <td colSpan="4">{authDetails.Subject}</td>
                            </tr>
                            <tr>
                                <td><small className='text-secondary'>Body:</small></td>
                                <td colSpan="4">{authDetails.Body}</td>
                            </tr>
                        </tbody>
                    </table>
                </AccordionDetails>
            </Accordion>
        )}
        <Typography component={'label'} style={{ marginRight: '5px' }}>Module Access:
            {submodules && submodules.length > 0 && submodules.map((each, index) => {
                let modulestatus = userMoudleStatus && userMoudleStatus.length > 0 && userMoudleStatus.find(ele => ele.SubModuleId == each.Id);
                return (
                    <Switch handleFieldValue={handleModuletoggle} value={each.checked ? each.checked : modulestatus ? modulestatus.SubModuleId === each.Id && modulestatus.Status == 'A' ? true : false : false} name={each.SubModuleName}
                        label={each.SubModuleName} extraProps={{ transformProps }} />
                );
            })}
        </Typography>
        {refresh}
        <br />
        <div class="clearfix py-2"></div>
        <div className={classes.root}>
            {data && data.length > 0 && (data || []).map((each, index) => {
                return <Accordion key={'parent-' + index}>
                    <AccordionSummary
                        style={{ maxHeight: '45px', minHeight: '45px' }}
                        expandIcon={<ExpandMoreIcon color='inherit' />}
                        aria-label="Expand"
                        aria-controls="additional-actions1-content"
                        id="additional-actions1-header"
                    >
                        {user && user.isprofile !== 'Y' ? (customProps.length <= 0 ? <FormControlLabel

                            aria-label="Acknowledge"
                            onFocus={(event) => event.stopPropagation()}
                            onClick={(event) => checkGroupSection(event, index)}
                            control={<Checkbox checked={each.checked || (each.items.every(item => item.checked === true) ? true : false)}
                                indeterminate={each.items.every(item => item.checked === true) ? false :
                                    handleIndetermineGroupCheck(each) ? true : groupIndeterminate[index]}
                            />}
                            label={<small className='fw-bold '>{each.text}</small>}
                        /> : <div className='fw-bold'>{each.text}</div>) : <div className='fw-bold'>{each.text}</div>}
                    </AccordionSummary>
                    <div className='col-12'>
                        <div className='row fw-bold' >
                            <div className=" col-3 mx-3">Roles</div>
                            <div className="col-7" >{getEnvVariable('ModuleKey') === 'AMES' ? 'Regions' : getEnvVariable('ModuleKey') === 'LAOACS' ? 'Parish' : 'Counties'}</div>
                        </div>
                        {/* style={{ color: 'white', backgroundColor: 'rgb(4 133 185)', }} */}
                    </div>
                    {each.items && each.items.length > 0 && (each.items || []).map((subeach, subindex) => {
                        return <AccordionDetails key={'child-' + subindex}>
                            <div className='row col-12 py-2'>
                                {user && isprofile !== 'Y' ? <div className='col-3 mx-3'><FormControlLabel
                                    aria-label="Acknowledge"
                                    onFocus={(event) => event.stopPropagation()}
                                    onClick={(event) => checkRoleSection(event, subindex, index)}
                                    control={<Checkbox checked={subeach.checked || subeach.items.every(item => item.checked === true)}
                                        //style={{ color: 'white' }}
                                        indeterminate={subeach.items.every(item => item.checked === true) ? false :
                                            (subeach.items.some(item => item.checked === true) ? true : false)}
                                    />}
                                    label={subeach.text}
                                /></div> : <div className='col'>{subeach.text}</div>}
                                {user && isprofile !== 'Y' ? <div className='col-7' >
                                    <CheckboxesTags limitTags={2} value={(subeach.items.map(function (a) { if (a.checked === true) return a.id })).join(',') || ''}
                                        ismulti={true} items={subeach.items} handleFieldValue={(evt) => handleCountyChange(evt, index, subindex)} extraProps={{
                                            transformProps: {
                                                label: 'text',
                                                value: 'id'
                                            }
                                        }}
                                    />
                                </div> :
                                    <div className='col-7' >{subeach.items.map(a => { if (a.checked === true) return <Chip label={a.text} className='ml-1' variant="outlined" /> })}</div>}
                            </div>
                        </AccordionDetails>
                    })}
                </Accordion>
            })}
        </div>
    </div>
}